<template>
    <div class="container">
        <h1 class="backgroundBlack">Ceník</h1>
        <div class="container">
            <div class="col-lg pt-lg-4">
                <p>Každé focení je jedinečné. Napište mi, jaké zachycení momentů by jste si přáli a já Vám navrhnu
                    cenu
                    přímo na míru tak, aby vyhovovala jak Vám, tak i mně.</p>
                <p>V případě zájmu o bližší informace mě neváhejte <a href="mailto:niki.we@seznam.cz">kontaktovat</a>.</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "price"
    }
</script>

<style scoped>
    h1 {
        padding-bottom: 0.5rem;
        padding-left: 15px;
        color: white;
        padding-top: 10px;
        font-size: 3.5rem;
    }

    .backgroundBlack {
        background-color: black;
    }
</style>